var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-name"},[_vm._v(" "+_vm._s(_vm.item.opportunity.name)+" "),_c('small',{staticClass:"d-block text-muted"},[_vm._v(_vm._s(_vm.item.project.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }